import Swal from 'sweetalert2';
import Cookies from 'js-cookie';

export default function alertAppDownload() {
    const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(navigator.userAgent);

    // if(true){ // pra testes
    if (isMobile && !window.matchMedia('(display-mode: standalone)').matches) {

        function shouldShowAlert() {
            return !Cookies.get('visited');
        }

        function setVisitedCookie() {               // 1min
            Cookies.set('visited', 'true', { expires: 1 / 1440, path: '/', sameSite: 'Lax'});
        }

        if (shouldShowAlert()) {

            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

            const swalOptions = {
                background: '#f3f3f3',
                color: '#333',
                confirmButtonColor: '#ffdf8d',
                customClass: { confirmButton: 'my-confirm-button' }
            };

            if (isSafari && isIOS) {
                Swal.fire({
                    ...swalOptions,
                    imageUrl: 'img/download-ios.png',
                    title: 'Adicione à tela de início!',
                    text: 'Siga os passos na imagem acima e deixe seus lançamentos ainda mais práticos',
                    confirmButtonText: 'Ok!',
                    imageWidth: 400,
                    imageAlt: 'Aperte o ícone de compartilhamento e em "Adicinar à Tela de Início"',
                });
            } else {
                Swal.fire({
                    ...swalOptions,
                    icon: 'info',
                    title: 'Instale o App!!',
                    text: 'Deixe seus lançamentos ainda mais práticos',
                    showCancelButton: true,
                    cancelButtonColor: '#707070',
                    cancelButtonText: 'Agora não',
                    confirmButtonText: 'Quero baixar!',
                    preConfirm: () => baixarApp(),
                    customClass: { ...swalOptions.customClass, container: 'my-container' }
                });

                // Preparação do prompt para instalação no Android
                let deferredPrompt;

                window.addEventListener('beforeinstallprompt', (event) => {
                    event.preventDefault();
                    deferredPrompt = event;
                });

                function baixarApp() {
                    deferredPrompt?.prompt();
                }
            }

            // Define o cookie de visita
            setVisitedCookie();
        }
    }
    // Estilos personalizados para o SweetAlert2
    const style = document.createElement('style');
    style.innerHTML = `
    .swal2-popup{
        font-family: "Poppins", Verdana, Tahoma, sans-serif
    }
    .swal2-actions {
        display: flex;
        flex-direction: row-reverse;
    }
    .my-confirm-button {
        color: #282964 !important;
    }
    body.swal2-height-auto {
        height: 100% !important;
    }
    `;
    document.head.appendChild(style);
}


